import MarksSlider from './MarksSlider';
import FormSelect from './FormSelect';

const EducationFields = ({ formData, dispatch, educationOptions, universityOptions }) => (
  <>
    <h3 className="font-semibold mb-2">🎓 Education</h3>
    <div className="mb-2">
      <FormSelect
        name="degree"
        value={formData.degree || ''}
        onChange={(e) => dispatch({ type: 'UPDATE_FIELD', field: 'degree', value: e.target.value })}
        options={educationOptions}
        placeholder="Select Degree"
      />
    </div>

    <div className="mb-2">
      <FormSelect
        name="university"
        value={formData.university || ''}
        onChange={(e) => dispatch({ type: 'UPDATE_FIELD', field: 'university', value: e.target.value })}
        options={universityOptions}
        placeholder="Select University"
      />
    </div>

    <input
      type="text"
      name="btechInstitute"
      placeholder="Name of the B.Tech Institute"
      value={formData.btechInstitute || ''}
      onChange={(e) => dispatch({ type: 'UPDATE_FIELD', field: 'btechInstitute', value: e.target.value })}
      className="w-full mb-3 px-4 py-3 theme-input rounded-lg theme-focus"
      style={{
        backgroundColor: 'var(--color-surface)',
        border: '2px solid var(--color-border)',
        color: 'var(--color-text)'
      }}
    />

    <input
      type="text"
      name="btechSpecialization"
      placeholder="Specialization / Branch (B.Tech)"
      value={formData.btechSpecialization || ''}
      onChange={(e) => dispatch({ type: 'UPDATE_FIELD', field: 'btechSpecialization', value: e.target.value })}
      className="w-full mb-3 px-4 py-3 theme-input rounded-lg theme-focus"
      style={{
        backgroundColor: 'var(--color-surface)',
        border: '2px solid var(--color-border)',
        color: 'var(--color-text)'
      }}
    />

    <input
      type="text"
      name="yearOfPassing"
      placeholder="Year of Passing"
      value={formData.yearOfPassing}
      onChange={(e) => dispatch({ type: 'UPDATE_FIELD', field: 'yearOfPassing', value: e.target.value })}
      className="w-full mb-3 px-4 py-3 theme-input rounded-lg theme-focus"
      style={{
        backgroundColor: 'var(--color-surface)',
        border: '2px solid var(--color-border)',
        color: 'var(--color-text)'
      }}
    />

    <MarksSlider
      label="B.Tech Marks"
      value={formData.btechMarks}
      field="btechMarks"
      dispatch={dispatch}
      marksType={formData.btechMarksType || 'Percentage'}
      marksTypeField="btechMarksType"
    />

    {/* M.Tech Fields */}
    <div 
      className="mt-6 pt-6 border-t-2" 
      style={{ 
        borderColor: 'var(--color-border)', 
        borderTopWidth: '2px', 
        paddingTop: '1.5rem', 
        marginTop: '1.5rem',
        backgroundColor: 'rgba(59, 130, 246, 0.05)',
        padding: '1.5rem',
        borderRadius: '8px',
        border: '2px solid rgba(59, 130, 246, 0.2)'
      }}
    >
      <h4 className="font-semibold mb-4 text-lg" style={{ color: 'var(--color-text)', fontWeight: '600' }}>🎓 M.Tech Information</h4>
      
      <input
        type="text"
        name="mtechInstitute"
        placeholder="College Name (M.Tech)"
        value={formData.mtechInstitute || ''}
        onChange={(e) => dispatch({ type: 'UPDATE_FIELD', field: 'mtechInstitute', value: e.target.value })}
        className="w-full mb-3 px-4 py-3 theme-input rounded-lg theme-focus"
        style={{
          backgroundColor: 'var(--color-surface)',
          border: '2px solid var(--color-border)',
          color: 'var(--color-text)'
        }}
      />

      <input
        type="text"
        name="mtechSpecialization"
        placeholder="Specialization (M.Tech)"
        value={formData.mtechSpecialization || ''}
        onChange={(e) => dispatch({ type: 'UPDATE_FIELD', field: 'mtechSpecialization', value: e.target.value })}
        className="w-full mb-3 px-4 py-3 theme-input rounded-lg theme-focus"
        style={{
          backgroundColor: 'var(--color-surface)',
          border: '2px solid var(--color-border)',
          color: 'var(--color-text)'
        }}
      />

      <input
        type="text"
        name="mtechYear"
        placeholder="Year of Passout (M.Tech)"
        value={formData.mtechYear || ''}
        onChange={(e) => dispatch({ type: 'UPDATE_FIELD', field: 'mtechYear', value: e.target.value })}
        className="w-full mb-3 px-4 py-3 theme-input rounded-lg theme-focus"
        style={{
          backgroundColor: 'var(--color-surface)',
          border: '2px solid var(--color-border)',
          color: 'var(--color-text)'
        }}
      />

      <MarksSlider
        label="M.Tech Marks"
        value={formData.mtechMarks}
        field="mtechMarks"
        dispatch={dispatch}
        marksType={formData.mtechMarksType || 'Percentage'}
        marksTypeField="mtechMarksType"
      />
    </div>

    {/* PhD Fields */}
    <div className="mt-6 pt-6 border-t-2" style={{ borderColor: 'var(--color-border)' }}>
      <h4 className="font-semibold mb-4 text-base" style={{ color: 'var(--color-text)' }}>🎓 PhD Information</h4>
      
      <label className="block mb-2 font-medium text-sm" style={{ color: 'var(--color-text)' }}>Have you done PhD?</label>
      <div className="flex gap-4 mb-2">
        <label className="flex items-center">
          <input
            type="radio"
            name="phdDone"
            value="Yes"
            checked={formData.phdDone === 'Yes'}
            onChange={(e) => dispatch({ type: 'UPDATE_FIELD', field: 'phdDone', value: e.target.value })}
            className="mr-2"
          />
          <span style={{ color: 'var(--color-text)' }}>Yes</span>
        </label>
        <label className="flex items-center">
          <input
            type="radio"
            name="phdDone"
            value="No"
            checked={formData.phdDone === 'No' || formData.phdDone === '' || !formData.phdDone}
            onChange={(e) => dispatch({ type: 'UPDATE_FIELD', field: 'phdDone', value: e.target.value })}
            className="mr-2"
          />
          <span style={{ color: 'var(--color-text)' }}>No</span>
        </label>
      </div>
      
      {formData.phdDone === 'Yes' && (
        <input
          type="text"
          name="phdYear"
          placeholder="Year of Passout of PhD"
          value={formData.phdYear || ''}
          onChange={(e) => dispatch({ type: 'UPDATE_FIELD', field: 'phdYear', value: e.target.value })}
          className="w-full mb-3 px-4 py-3 theme-input rounded-lg theme-focus"
          style={{
            backgroundColor: 'var(--color-surface)',
            border: '2px solid var(--color-border)',
            color: 'var(--color-text)'
          }}
        />
      )}
    </div>

    {/* Gap in Education Fields */}
    <div className="mt-4 pt-4 border-t">
      <h4 className="font-semibold mb-3 text-sm">📊 Education Gap Information</h4>
      
      {/* Gap in Education */}
      <div className="mb-4">
        <label className="block mb-2 font-medium text-sm">Any Gap in Education?</label>
        <div className="flex gap-4 mb-2">
          <label className="flex items-center">
            <input
              type="radio"
              name="hasGapInEducation"
              value="Yes"
              checked={formData.hasGapInEducation === 'Yes' || formData.hasGapInEducation === true || formData.hasGapInEducation === 'true'}
              onChange={(e) => {
                const value = e.target.value === 'Yes' ? 'Yes' : 'No';
                dispatch({ 
                  type: 'UPDATE_FIELD', 
                  field: 'hasGapInEducation', 
                  value: value
                });
              }}
              className="mr-2"
            />
            Yes
          </label>
          <label className="flex items-center">
            <input
              type="radio"
              name="hasGapInEducation"
              value="No"
              checked={formData.hasGapInEducation === 'No' || formData.hasGapInEducation === false || formData.hasGapInEducation === 'false' || formData.hasGapInEducation === '' || formData.hasGapInEducation === null || formData.hasGapInEducation === undefined}
              onChange={(e) => {
                const value = e.target.value === 'No' ? 'No' : 'Yes';
                dispatch({ 
                  type: 'UPDATE_FIELD', 
                  field: 'hasGapInEducation', 
                  value: value
                });
              }}
              className="mr-2"
            />
            No
          </label>
        </div>
        {(formData.hasGapInEducation === 'Yes' || formData.hasGapInEducation === true || formData.hasGapInEducation === 'true') && (
          <textarea
            name="gapInEducationJustification"
            placeholder="Please justify the gap in education"
            value={formData.gapInEducationJustification || ''}
            onChange={(e) => dispatch({ type: 'UPDATE_FIELD', field: 'gapInEducationJustification', value: e.target.value })}
            className="w-full mb-2 px-4 py-2 border rounded theme-input"
            style={{ 
              backgroundColor: 'var(--color-surface)',
              border: '2px solid var(--color-border)',
              color: 'var(--color-text)'
            }}
            rows="3"
            required
          />
        )}
      </div>

      {/* Gap After Highest Education */}
      <div className="mb-4">
        <label className="block mb-2 font-medium text-sm">Any Gap After Highest Education?</label>
        <div className="flex gap-4 mb-2">
          <label className="flex items-center">
            <input
              type="radio"
              name="hasGapAfterHighestEducation"
              value="Yes"
              checked={formData.hasGapAfterHighestEducation === 'Yes' || formData.hasGapAfterHighestEducation === true || formData.hasGapAfterHighestEducation === 'true'}
              onChange={(e) => {
                const value = e.target.value === 'Yes' ? 'Yes' : 'No';
                dispatch({ 
                  type: 'UPDATE_FIELD', 
                  field: 'hasGapAfterHighestEducation', 
                  value: value
                });
              }}
              className="mr-2"
            />
            Yes
          </label>
          <label className="flex items-center">
            <input
              type="radio"
              name="hasGapAfterHighestEducation"
              value="No"
              checked={formData.hasGapAfterHighestEducation === 'No' || formData.hasGapAfterHighestEducation === false || formData.hasGapAfterHighestEducation === 'false' || formData.hasGapAfterHighestEducation === '' || formData.hasGapAfterHighestEducation === null || formData.hasGapAfterHighestEducation === undefined}
              onChange={(e) => {
                const value = e.target.value === 'No' ? 'No' : 'Yes';
                dispatch({ 
                  type: 'UPDATE_FIELD', 
                  field: 'hasGapAfterHighestEducation', 
                  value: value
                });
              }}
              className="mr-2"
            />
            No
          </label>
        </div>
        {(formData.hasGapAfterHighestEducation === 'Yes' || formData.hasGapAfterHighestEducation === true || formData.hasGapAfterHighestEducation === 'true') && (
          <textarea
            name="gapAfterHighestEducationJustification"
            placeholder="Please justify the gap after highest education"
            value={formData.gapAfterHighestEducationJustification || ''}
            onChange={(e) => dispatch({ type: 'UPDATE_FIELD', field: 'gapAfterHighestEducationJustification', value: e.target.value })}
            className="w-full mb-2 px-4 py-2 border rounded theme-input"
            style={{ 
              backgroundColor: 'var(--color-surface)',
              border: '2px solid var(--color-border)',
              color: 'var(--color-text)'
            }}
            rows="3"
            required
          />
        )}
      </div>
    </div>
  </>
);

export default EducationFields;

